var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFromCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 45.063c-11.613 0-21.063-9.45-21.063-21.063S12.387 2.937 24 2.937 45.063 12.387 45.063 24 35.612 45.063 24 45.063zm0-38.297c-9.504 0-17.234 7.73-17.234 17.234 0 9.504 7.73 17.234 17.234 17.234 9.504 0 17.234-7.73 17.234-17.234 0-9.504-7.73-17.234-17.234-17.234zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.66 25.914H16.34A1.912 1.912 0 0114.426 24c0-1.059.855-1.914 1.914-1.914h15.32c1.059 0 1.914.855 1.914 1.914a1.912 1.912 0 01-1.914 1.914zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFromCart);
export default __webpack_public_path__ + "static/media/RemoveFromCart.588e1eba0719779307413ce7319148ef.svg";
export { ForwardRef as ReactComponent };